import {
    Box,
    Button,
    CircularProgress,
    Grid,
    InputAdornment,
    Paper,
    TextField,
    Typography,
    useMediaQuery, useTheme,
    Dialog, DialogActions, DialogContent,
    DialogTitle
} from '@material-ui/core';
import Fade from '@material-ui/core/Fade';
import BlueButton from '../components/button/BlueButton';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';
import debounce from 'lodash.debounce';
import React, { useCallback, useEffect, useState } from 'react';
import MenuComponent from '../components/menu/menu-component';
import CustomTablePagination from '../components/pagination/pagination-component';
import authService from '../Services/auth/auth-service';
import estoqueService from '../Services/Estoque/estoque-service';
import usuarioService from '../Services/Usuario/usuario-service';
import FilesExportFilterEstoque from '../servicos/components/filesExportFilterEstoque';
import AssignmentIcon from '@mui/icons-material/Assignment';
import moment from 'moment';

const useStyles = makeStyles(() => ({
    mensagemStyle: {
        fontFamily: 'Mont, sans-serif',
        color: '#209BDE',
        fontSize: '18px',
        textAlign: 'start',
        padding: '0 0px',
    },
    paper: {
        marginBottom: 20,
        display: 'flex',
        flexDirection: 'column',
        padding: '15px 20px 15px',
        borderRadius: 10,
    },
    tituloStyle: {
        fontFamily: 'Mont, sans-serif',
        color: '#209BDE',
        fontSize: '22px',
        textAlign: 'start',
        padding: '0 0px',
        marginBottom: '5px',
    },
    subtituloStyle: {
        fontFamily: 'Mont, sans-serif',
        color: '#7F7F7F',
        fontSize: '16px',
        fontWeight: 'inherit',
        textAlign: 'start',
        padding: '0 0px',
        marginTop: '0px',
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
    },
}));

export default function HistoricoEstoquePage({ microSigaID, handleCloseHistoricoEstoque, nomeTecnico, idTecnico }) {
    const classes = useStyles();
    const [estoqueItens, setEstoque] = useState([]);
    const [, setUsuarioGestor] = useState(false);
    const [usuarioEstoqueAtivo, setUsuarioEstoqueAtivo] = useState(false);
    const [carregandoTable, setCarregandoTable] = useState(false);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [pageSize, setPageSize] = useState(isMobile ? 8 : 8);
    const [totalDados, setTotalDados] = useState(0);
    const [pesquisa, setPesquisa] = useState('');
    const isDesktop = useMediaQuery('(min-width:430px)');
    const [temPermissao, setTemPermissao] = useState(true);
    const [carregandoHistoricoProduto, setCarregandoHistoricoProduto] = useState(false);
    const [abrirModalHistorico, setAbrirModalHistorico] = useState(false);
    const [codigoProduto, setCodigoProduto] = useState('');
    const [pageHistorico, setPageHistorico] = useState(0);
    const [pageSizeHistorico, setPageSizeHistorico] = useState(8);
    const [carregandoTableHistorico, setCarregandoTableHistorico] = useState(false);
    const [historicoEstoque, setHistoricoEstoque] = useState([]);
    const [pesquisaHistorico, setPesquisaHistorico] = useState('');
    const [totalDadosHistorico, setTotalDadosHistorico] = useState(0);

    useEffect(() => {
        const usuarioInfo = authService.getUserInfo().usuario;
        const permissaoAgendaGlobal = usuarioInfo.permissaoUsuario;

        const tecnicoPrestador = usuarioInfo.tecnicoPrestador;
        const empresa = usuarioInfo.empresa;
        const tecnico = usuarioInfo.tecnico;
        let temPermissao = true;

        if (empresa || tecnico) {

            temPermissao = permissaoAgendaGlobal?.some(permissao =>
                permissao.permissoesLista?.some(permissaoItem =>
                    permissaoItem.trim() === 'cod_historico_estoque'
                )
            );
        } else {
            temPermissao = true;
        }

        if (!temPermissao) {
            setTemPermissao(false);
        } else {
            setTemPermissao(true);
        }
        if (tecnicoPrestador && !temPermissao) {
            return;
        }

    }, []);

    const [dadosExportacao, setDadosExportacao] = useState([]);

    const carregarDadosExportacao = async () => {
        const area = microSigaID || authService.getUserInfo().usuario.tz_area_atendimento_microsigaid;

        const dados = {
            AreaAtendimentoId: area,
            Limite: totalDados,
            Pagina: 0,
            Pesquisa: pesquisa || '',
        };

        try {
            const response = await estoqueService.listarEstoqueConsolidado(dados);

            if (response && response.dados) {
                setDadosExportacao(
                    response.dados.map((item) => ({
                        Nome: item.produtoNome || 'Indisponível',
                        Código: item.produtoCodigo || 'Indisponível',
                        Disponível: item.quantidadeDisponivel || 0,
                        Recusado: item.quantidadeRecusadoTecnico || 0,
                        Reversa: item.quantidadeReversa || 0,
                        Devolver: item.quantidadeDevolver || 0,
                        Reservado: item.quantidadeReservado || 0,
                        RecusadoFabrica: item.quantidadeRecusadoFabrica || 0,
                    }))
                );
            } else {
                setDadosExportacao([]);
            }
        } catch (error) {
            console.error('Erro ao carregar dados para exportação:', error);
            setDadosExportacao([]);
        }
    };

    const delayPesquisa = useCallback(
        debounce((nome) => {
            setPage(0);
            estoque(0, pageSize, nome);
        }, 700), []
    );

    const pesquisarDados = (nome) => {
        if (nome !== pesquisa) {
            setPesquisa(nome);
            delayPesquisa(nome);
        }
    };

    const buscarUsuarioEstoqueAtivo = async () => {
        let idUsuario = idTecnico || authService.getUserInfo().usuario.id;
        const response = await usuarioService.usuarioEstoqueAtivo(idUsuario);
        if (response.error) {
            return;
        } else {
            setUsuarioEstoqueAtivo(response);
        }
    };

    useEffect(() => {
        carregarDadosExportacao();
    }, [pesquisa, totalDados]);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await estoque(page, pageSize, pesquisa);
            await buscarUsuarioEstoqueAtivo();
            setUsuarioGestor(authService.getUserInfo().usuario.gestor);
            setLoading(false);
        };
        fetchData();
    }, [isMobile, isDesktop]);

    const mudarPagina = (event, newPage) => {
        setPage(newPage);
        estoque(newPage, pageSize, searchTerm);
    };

    const mudarTamanhoPagina = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPage(0);
        estoque(0, newPageSize, searchTerm);
    };

    const estoque = async (currentPage = 0, currentPageSize = 6, currentPesquisa = '') => {
        setCarregandoTable(true);
        let area = microSigaID || authService.getUserInfo().usuario.tz_area_atendimento_microsigaid;

        const dados = {
            AreaAtendimentoId: area,
            Limite: currentPageSize,
            Pagina: currentPage,
            Pesquisa: currentPesquisa || '',
        };

        let estoqueLista = await estoqueService.listarEstoqueConsolidado(dados);

        if (estoqueLista && estoqueLista.dados) {
            setEstoque(estoqueLista.dados);
            setTotalDados(estoqueLista.total);
        } else {
            setEstoque([]);
            setTotalDados(0);
        }

        setCarregandoTable(false);
    };

    const modalHistorico = async (produtoCodigo) => {
        if (!produtoCodigo) {
            return;
        }
        setCodigoProduto(produtoCodigo);
        setCarregandoHistoricoProduto(produtoCodigo);
        setPageHistorico(0);
        setAbrirModalHistorico(true);
        await carregarHistorico(produtoCodigo, 0, pageSizeHistorico, pesquisaHistorico);
        setCarregandoHistoricoProduto(null);
    };

    const carregarHistorico = async (codigoProduto, pageHistorico, pageSizeHistorico, pesquisaHistorico) => {
        if (!codigoProduto) {
            return;
        }

        setCarregandoTableHistorico(true);

        try {
            let area = microSigaID || authService.getUserInfo().usuario.tz_area_atendimento_microsigaid;

            const dados = {
                AreaAtendimentoId: area,
                CodigoProduto: codigoProduto,
                Limite: pageSizeHistorico,
                Pesquisa: pesquisaHistorico,
                Pagina: pageHistorico,
            };
            const response = await estoqueService.listarHistoricoEstoque(dados);

            if (response && response.item2) {
                setTotalDadosHistorico(response.item1 || 0);
                setHistoricoEstoque(response.item2);
            } else {
                setHistoricoEstoque([]);
            }
        } catch (error) {
            setHistoricoEstoque([]);
        } finally {
            setCarregandoTableHistorico(false);
        }
    };

    const fecharModalHistorico = () => {
        setAbrirModalHistorico(false);
        setHistoricoEstoque([]);
        setCodigoProduto('');
        setPesquisaHistorico('');
        setPageHistorico(0);
        setPageSizeHistorico(8);
    };

    const mudarTamanhoPaginaHistorico = (event) => {
        const newPageSizeHistorico = parseInt(event.target.value, 10);
        setPageSizeHistorico(newPageSizeHistorico);
        setPageHistorico(0);
        carregarHistorico(codigoProduto, 0, newPageSizeHistorico, pesquisaHistorico);
    };

    const mudarPaginaHistorico = (event, newPage) => {
        setPageHistorico(newPage);
        carregarHistorico(codigoProduto, newPage, pageSizeHistorico, pesquisaHistorico);
    };

    const delayPesquisaHistorico = useCallback(
        debounce((nome) => {
            setPageHistorico(0);
            carregarHistorico(codigoProduto, 0, pageSizeHistorico, nome);
        }, 700), []
    );

    const handleHistoricoSearch = (nome) => {
        setPesquisaHistorico(nome);
        delayPesquisaHistorico(nome);
    };

    if (loading) {
        return (
            <div className={classes.loadingContainer}>
                <CircularProgress />
            </div>
        );
    }

    return (
        <>
            <MenuComponent />
            <div style={{ margin: 30 }}>
                <h3 className={classes.tituloStyle}>Histórico de Estoque</h3>
                <h4 className={classes.subtituloStyle}>
                    <span
                        onClick={() => {
                            const userInfo = authService.getUserInfo();
                            if (userInfo.usuario.gestor) {
                                window.location.assign('/gestor');
                            } else {
                                window.location.assign('/agenda');
                            }
                        }}
                        className={classes.linkStyle}
                        style={{ cursor: 'pointer' }}
                    >
                        Home
                    </span>
                    {' > '}
                    Estoque
                    {' > '}
                    Histórico de Estoque
                    {authService.getUserInfo().usuario.gestor === true &&
                        nomeTecnico &&
                        nomeTecnico.trim() !== '' ? (
                        <>
                            {' > '}
                            {nomeTecnico}
                        </>
                    ) : null}
                </h4>

                {authService.getUserInfo().usuario.gestor === true &&
                    nomeTecnico &&
                    nomeTecnico.trim() !== '' ? (
                    <Grid item xs={3} sm={1} md={1}>
                        <Button
                            onClick={handleCloseHistoricoEstoque}
                            style={{ color: '#209BDE' }}
                            startIcon={<ArrowBackIosIcon />}
                        >
                            Voltar
                        </Button>
                    </Grid>
                ) : null}

                {temPermissao && usuarioEstoqueAtivo ? (
                    <>
                        <Dialog
                            open={abrirModalHistorico}
                            onClose={(e, reason) => reason !== 'backdropClick' && fecharModalHistorico()}
                            fullWidth
                            maxWidth="md"
                            PaperProps={{
                                style: {
                                    width: isMobile ? '100%' : 950,
                                    maxWidth: '100%',
                                    height: '650px',
                                    marginTop: isMobile ? 80 : 45,
                                    marginBottom: isMobile ? 25 : 10,
                                    display: 'flex',
                                    flexDirection: 'column'
                                }
                            }}
                            TransitionComponent={Fade}
                            transitionDuration={300}
                        >
                            <DialogTitle>
                                <Grid container alignItems="center">
                                    <Grid item xs={10} sm={11}>
                                        Histórico do Produto
                                    </Grid>
                                    <Grid item xs={2} sm={1}>
                                        <IconButton onClick={fecharModalHistorico}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>
                            </DialogTitle>
                            <DialogContent
                                dividers
                                style={{
                                    flex: 1,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    padding: 16,
                                    overflow: 'hidden'
                                }}
                            >
                                <Box mb={2}>
                                    <Grid container justifyContent="flex-end">
                                        <Grid item xs={isMobile ? 12 : 5}>
                                            <TextField
                                                label="Pesquisar"
                                                variant="outlined"
                                                fullWidth
                                                value={pesquisaHistorico}
                                                onChange={(e) => {
                                                    const term = e.target.value;
                                                    handleHistoricoSearch(term);
                                                }}
                                                style={{ marginBottom: '16px' }}
                                                InputProps={{
                                                    endAdornment: (
                                                        <>
                                                            {pesquisa ? (
                                                                <IconButton
                                                                    onClick={() => {
                                                                        setPesquisaHistorico('');
                                                                        handleHistoricoSearch('');
                                                                    }}
                                                                >
                                                                    <CloseIcon />
                                                                </IconButton>
                                                            ) : (
                                                                <InputAdornment position="end">
                                                                    <SearchIcon />
                                                                </InputAdornment>
                                                            )}
                                                        </>
                                                    ),
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                                {carregandoTableHistorico ? (
                                    <div className={classes.loadingContainer}>
                                        <CircularProgress />
                                    </div>
                                ) : isMobile ? (
                                    <Grid container spacing={2}>
                                        {historicoEstoque.length > 0 ? (
                                            historicoEstoque.map((item, index) => (
                                                <Grid item xs={12} key={index}>
                                                    <Paper style={{ padding: '16px' }}>
                                                        <Box padding={1} style={{ flexGrow: 1 }}>
                                                            <Typography component="div" variant="body2">
                                                                <strong>Código:</strong> {item.produtoCodigo}
                                                            </Typography>
                                                            <Typography component="div" variant="body2">
                                                                <strong>Nome:</strong> {item.produtoNome}
                                                            </Typography>
                                                            <Typography component="div" variant="body2">
                                                                <strong>Qtd.:</strong> 1
                                                            </Typography>
                                                            <Typography component="div" variant="body2">
                                                                <strong>Data Utilização:</strong> {item.dataAlteracao ? moment(item.dataAlteracao).format('DD/MM/YYYY HH:mm:ss') : ''}
                                                            </Typography>
                                                            <Typography component="div" variant="body2">
                                                                <strong>NA:</strong> {item.numeroNA}
                                                            </Typography>
                                                            <Typography component="div" variant="body2">
                                                                <strong>Serial:</strong> {item.serie}
                                                            </Typography>
                                                        </Box>
                                                    </Paper>
                                                </Grid>
                                            ))
                                        ) : (
                                            <Grid container justifyContent="center" alignItems="center" style={{ margin: 10 }}>
                                                <Typography variant="subtitle1" color="textSecondary">
                                                    Nenhum histórico encontrado.
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>
                                ) : (
                                    historicoEstoque.length > 0 && (
                                        <Grid container>
                                            <Grid item xs={2}>
                                                <Typography style={{ fontWeight: 'bold' }}>Código</Typography>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography style={{ fontWeight: 'bold' }}>Nome</Typography>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <Typography style={{ fontWeight: 'bold' }}>Qtd.</Typography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography style={{ fontWeight: 'bold' }}>Data Utilização</Typography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography style={{ fontWeight: 'bold' }}>NA</Typography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <Typography style={{ fontWeight: 'bold' }}>Serial</Typography>
                                            </Grid>

                                        </Grid>
                                    )
                                )}
                                {!isMobile && (
                                    <>
                                        <Box style={{ flex: 1, overflowY: 'auto' }}>
                                            {historicoEstoque.length > 0 ? (
                                                historicoEstoque.map((item, index) => (
                                                    <Grid container key={index} style={{ padding: '8px 0' }} wrap="wrap">
                                                        <Grid item xs={2}>
                                                            <Typography component="div" variant="body2">{item.produtoCodigo}</Typography>
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <Typography component="div" variant="body2">{item.produtoNome}</Typography>
                                                        </Grid>
                                                        <Grid item xs={1}>
                                                            <Typography component="div" variant="body2">1</Typography>
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            <Typography component="div" variant="body2">{item.dataAlteracao ? moment(item.dataAlteracao).format('DD/MM/YYYY HH:mm:ss') : ''}</Typography>
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            <Typography component="div" variant="body2">{item.numeroNA}</Typography>
                                                        </Grid>
                                                        <Grid item xs={2}>
                                                            <Typography component="div" variant="body2">{item.serie}</Typography>
                                                        </Grid>
                                                    </Grid>
                                                ))
                                            ) : (
                                                <Grid container justifyContent="center" alignItems="center" style={{ marginTop: 10 }}>
                                                    <Typography variant="subtitle1" color="textSecondary">
                                                        Nenhum histórico encontrado.
                                                    </Typography>
                                                </Grid>
                                            )}
                                        </Box>
                                    </>
                                )}
                                {historicoEstoque.length > 0 && (
                                    <Grid container justifyContent="center" alignItems="center" spacing={1} style={{ marginTop: 10 }}>
                                        <Grid item>
                                            <CustomTablePagination
                                                count={totalDadosHistorico}
                                                page={pageHistorico}
                                                rowsPerPage={pageSizeHistorico}
                                                onPageChange={mudarPaginaHistorico}
                                                quantidadeItens={totalDadosHistorico}
                                                onRowsPerPageChange={mudarTamanhoPaginaHistorico}
                                            />
                                        </Grid>
                                    </Grid>
                                )}
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    variant="contained"
                                    style={{ float: 'right', width: '40%', height: 55 }}
                                    onClick={fecharModalHistorico}
                                >
                                    Fechar
                                </Button>
                            </DialogActions>
                        </Dialog>

                        <Grid container justifyContent="flex-end">
                            <Grid item xs={isMobile ? 12 : 5}>
                                <TextField
                                    label="Pesquisar"
                                    variant="outlined"
                                    fullWidth
                                    value={searchTerm}
                                    onChange={(e) => {
                                        const term = e.target.value;
                                        setSearchTerm(term);
                                        pesquisarDados(term);
                                    }}
                                    style={{ marginBottom: '16px' }}
                                    InputProps={{
                                        endAdornment: (
                                            <>
                                                {searchTerm ? (
                                                    <IconButton
                                                        onClick={() => {
                                                            setSearchTerm('');
                                                            pesquisarDados('');
                                                        }}
                                                        size="small"
                                                    >
                                                        <CloseIcon />
                                                    </IconButton>
                                                ) : (
                                                    <InputAdornment position="end">
                                                        <SearchIcon />
                                                    </InputAdornment>
                                                )}
                                            </>
                                        ),
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Paper className={classes.paper}>
                            <Grid container justifyContent="flex-end">
                                <Grid item xs={isMobile ? 12 : 10}>
                                </Grid>
                                <Grid
                                    item
                                    xs={isMobile ? 12 : 2}
                                    style={{ paddingBottom: 15 }}
                                >
                                    {estoqueItens.length > 0 && (
                                        <FilesExportFilterEstoque
                                            fileName={nomeTecnico ? `Histórico  ${nomeTecnico}` : 'Meu Histórico Completo'}
                                            data={dadosExportacao}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                            {carregandoTable ? (
                                <Grid container justifyContent="center" alignItems="center" style={{ height: '400px' }}>
                                    <CircularProgress />
                                </Grid>
                            ) : estoqueItens.length === 0 ? (
                                <Grid container justifyContent="center" alignItems="center" >
                                    <Typography variant="subtitle1" color="textSecondary">
                                        Não há itens para exibir.
                                    </Typography>
                                </Grid>
                            ) : (
                                <Grid container spacing={1}>
                                    {estoqueItens.length > 0 ? (
                                        estoqueItens.map((item, index) => (
                                            <Grid item key={index} xs={12} md={3} style={{ width: '100%', maxWidth: '100%' }}>
                                                <Paper
                                                    style={{
                                                        padding: '16px',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        justifyContent: 'space-between',
                                                        height: '100%',
                                                        boxSizing: 'border-box',
                                                    }}
                                                >
                                                    <Box padding={1} style={{ flexGrow: 1 }} key={index}>
                                                        <Typography component="div" variant="body2" style={{ marginBottom: 10 }}> {item.produtoNome} </Typography>
                                                        <Typography component="div" variant="body2"><strong>Disponível:</strong> {item.quantidadeDisponivel}</Typography>
                                                        <Typography component="div" variant="body2"><strong>Utilizado:</strong> {item.quantidadeUtilizada}</Typography>
                                                        <Typography component="div" variant="body2"><strong>Total:</strong> {item.quantidadeUtilizada + item.quantidadeDisponivel}</Typography>
                                                        <Typography component="div" variant="body2"><strong>Reversa:</strong> {item.quantidadeReversa}</Typography>
                                                    </Box>
                                                    <Grid container spacing={1} style={{ marginTop: 5 }}>
                                                        <Grid item xs={12} sm={12}>
                                                            <BlueButton
                                                                variant="contained"
                                                                color="primary"
                                                                size="large"
                                                                fullWidth
                                                                style={{ height: 55 }}
                                                                startIcon={
                                                                    carregandoHistoricoProduto === item.produtoCodigo ? (
                                                                        <CircularProgress size={20} />
                                                                    ) : (
                                                                        <AssignmentIcon />
                                                                    )
                                                                }
                                                                onClick={() => modalHistorico(item.produtoCodigo)}
                                                                disabled={carregandoHistoricoProduto === item.produtoCodigo}
                                                            >
                                                                <span style={{ fontSize: '0.7rem' }}>{carregandoHistoricoProduto === item.produtoCodigo ? 'Carregando...' : 'Ver Histórico'}</span>
                                                            </BlueButton>
                                                        </Grid>
                                                    </Grid>
                                                </Paper>
                                            </Grid>
                                        ))
                                    ) : (
                                        <Grid item xs={12}>
                                            <Typography align="center">Nenhum registro para exibir</Typography>
                                        </Grid>
                                    )}

                                    <Grid container justifyContent="center" alignItems="center" spacing={1} style={{ marginTop: 10 }}>
                                        <Grid item>
                                            {totalDados > 0 && (
                                                <CustomTablePagination
                                                    count={totalDados}
                                                    page={page}
                                                    quantidadeItens={totalDados}
                                                    rowsPerPage={pageSize}
                                                    onPageChange={mudarPagina}
                                                    onRowsPerPageChange={mudarTamanhoPagina}
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>
                            )}
                        </Paper>
                    </>
                ) : (
                    <>
                        <Paper className={classes.paper}>
                            <Grid container justifyContent="center">
                                {authService.getUserInfo().usuario.gestor === true && usuarioEstoqueAtivo === false ? (
                                    <h2 className={classes.mensagemStyle} style={{ padding: 30 }}>O usuário não possui o estoque liberado!</h2>
                                ) : (
                                    <h2 className={classes.mensagemStyle} style={{ padding: 30 }}>Você não tem permissão para acessar esta página!</h2>
                                )}
                            </Grid>
                        </Paper>
                    </>
                )}
            </div >
        </>
    );
}
